const FULFILLED_STATUS = 'fulfilled' as const;
const REJECTED_STATUS = 'rejected' as const;

export type SettledResult<T> =
  { status: typeof FULFILLED_STATUS; value: T }
  | { status: typeof REJECTED_STATUS; reason: unknown };

export function settle<T>(unsettled: () => T): SettledResult<T>;
export function settle<T>(unsettled: Promise<T>): Promise<SettledResult<T>>;
export function settle<T>(
  unsettled: (() => T) | Promise<T>
): SettledResult<T> | Promise<SettledResult<T>> {
  switch (typeof unsettled) {
    case 'function':
      try {
        return {
          status: FULFILLED_STATUS,
          value: unsettled(),
        };
      } catch (reason) {
        return {
          status: REJECTED_STATUS,
          reason,
        };
      }
    default:
      return unsettled
        .then(value => ({
          status: FULFILLED_STATUS,
          value,
        }))
        .catch((reason: unknown) => ({
          status: REJECTED_STATUS,
          reason,
        }));
  }
}